export default __webpack_public_path__ + "static/media/037-statistics.e04fc7f6.svg";